import { FieldProps } from "@/core/components/Field";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import { Accordion } from "@mui/material";
import { AccordionContent } from "@/core/types/types";
import AccordionSummaryText from "./AccordionSummaryText";
import AccordionDetails from "./AccordionDetails";
import { useTheme, Theme } from "@mui/system";

const AccordionField = ({ field }: FieldProps) => {
  const accordionContent: AccordionContent | undefined =
    field.properties?.content;
  const theme: Theme = useTheme();
  const border: string = `1px solid ${theme.palette.grey.A700}`;

  return (
    <Accordion
      sx={{
        border,
        boxShadow: "none",
      }}
    >
      <AccordionSummaryText text={t(field.text)} />
      <AccordionDetails contentType={accordionContent} />
    </Accordion>
  );
};

export default AccordionField;
